import React from 'react';
import DOM from 'react-dom-factories';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import css from './CwImage.scss';
import cx from 'classnames';
import BrowserUserAgent from '../../utils/BrowserUserAgent';
import changeCheck from '../../utils/ChangeCheck';

class CwImage extends React.Component {
  shouldComponentUpdate(nextProps) {
    const propsToCheck = ['src', 'alt', 'isInlineSVG', 'className'];
    return changeCheck(propsToCheck, this.props, nextProps);
  };

  render() {
    let is_chrome = BrowserUserAgent.is_chrome();
    let is_safari = BrowserUserAgent.is_safari();
    if ((is_chrome) && (is_safari)) {
      is_safari = false;
    }

    const imageClass = cx(this.props.className, {
      [css.cursor]: this.props.onClick
    });

    if (this.props.isInlineSVG) {
      return (
        <div
          data-cwid={this.props.cwId}
          onClick={this.props.onClick}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}>
          <Isvg
            className={imageClass}
            style={this.props.style}
            wrapper={DOM.div}
            key={this.props.src}
            src={this.props.src}
            cacheGetRequests={true}
          />
        </div>
      );
    }

    if (is_safari) {
      return (
        <div
          data-cwid={this.props.cwId}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}>
          <img
            className={imageClass}
            style={this.props.style}
            src={this.props.src}
            alt={this.props.alt}
            onClick={this.props.onClick}
          />
        </div>
      );
    }
    else {
      return (
        <img
          data-cwid={this.props.cwId}
          className={imageClass}
          style={this.props.style}
          src={this.props.src}
          alt={this.props.alt}
          onClick={this.props.onClick}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
        />
      );
    }
  }
}

CwImage.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Path to image
   */
  src: PropTypes.string.isRequired,
  /**
   * Callback fired when image is clicked
   */
  onClick: PropTypes.func,
  /**
   * Alt text used for screen readers
   */
  alt: PropTypes.string,
  /**
   * Controls whether svg or img tag is rendered
   */
  isInlineSVG: PropTypes.bool,
  /**
   * Used to add custom css
   */
  className: PropTypes.string,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Override the styles of the root element
   */
  style: PropTypes.object,
};

CwImage.defaultProps = {
  isInlineSVG: true,
};

export default CwImage;


// WEBPACK FOOTER //
// ./src/components/cwimage/CwImage.jsx